// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1bK4X","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__XIHsj"};